import _ from 'lodash';

export const generateRandom = (suffix) => {
  return [Math.random().toString(36).slice(2,7), Date.now().toString(36).substring(4), '-', suffix].join("");
}

export const capitalizeArtistName = (name) => name && name.split(/ |-/).map((word) => word.replace(/(^\w)/, c => c.toUpperCase())).join(' ')
